import { StarredDisplayModeEnum } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

/** Order in the dropdown; `ShowAllWithoutStarred` is last (manual-only, not in toolbar cycle). */
export const starredModes = [
  StarredDisplayModeEnum.ShowAllIncludeStarred,
  StarredDisplayModeEnum.FiltersApplied,
  StarredDisplayModeEnum.FiltersIgnored,
  StarredDisplayModeEnum.ShowAllWithoutStarred,
] as const;

const STARRED_DISPLAY_MODES_CYCLE_ORDER = [
  StarredDisplayModeEnum.ShowAllIncludeStarred,
  StarredDisplayModeEnum.FiltersApplied,
  StarredDisplayModeEnum.FiltersIgnored,
] as const;

const isStarredDisplayModeInCycle = (
  value: StarredDisplayModeEnum,
): value is (typeof STARRED_DISPLAY_MODES_CYCLE_ORDER)[number] =>
  value === StarredDisplayModeEnum.ShowAllIncludeStarred ||
  value === StarredDisplayModeEnum.FiltersApplied ||
  value === StarredDisplayModeEnum.FiltersIgnored;

export const getNextStarredDisplayModeForCycle = (
  current: StarredDisplayModeEnum,
): StarredDisplayModeEnum => {
  if (!isStarredDisplayModeInCycle(current)) {
    return StarredDisplayModeEnum.ShowAllIncludeStarred;
  }

  const index = STARRED_DISPLAY_MODES_CYCLE_ORDER.indexOf(current);
  const nextIndex = (index + 1) % STARRED_DISPLAY_MODES_CYCLE_ORDER.length;
  return STARRED_DISPLAY_MODES_CYCLE_ORDER[nextIndex];
};

export const getStarFillColor = (value: StarredDisplayModeEnum): string => {
  switch (value) {
    case StarredDisplayModeEnum.FiltersApplied:
      return rydeColors.yellow;
    case StarredDisplayModeEnum.FiltersIgnored:
      return rydeColors.orange;
    case StarredDisplayModeEnum.ShowAllWithoutStarred:
      return rydeColors.midGrey;
    default:
      return rydeColors.lightGreyBorder;
  }
};

export const getStarStrokeColor = (value: StarredDisplayModeEnum): string => {
  switch (value) {
    case StarredDisplayModeEnum.FiltersApplied:
      return rydeColors.yellow;
    case StarredDisplayModeEnum.FiltersIgnored:
      return rydeColors.orange;
    case StarredDisplayModeEnum.ShowAllWithoutStarred:
      return rydeColors.lightGreyBorder;
    default:
      return rydeColors.grey;
  }
};

export const optionStarredTranslationKeyByValue = (
  value: StarredDisplayModeEnum,
): string => {
  switch (value) {
    case StarredDisplayModeEnum.FiltersApplied:
      return `selectListLabel.${StarredDisplayModeEnum.FiltersApplied}`;
    case StarredDisplayModeEnum.FiltersIgnored:
      return `selectListLabel.${StarredDisplayModeEnum.FiltersIgnored}`;
    case StarredDisplayModeEnum.ShowAllWithoutStarred:
      return `selectListLabel.${StarredDisplayModeEnum.ShowAllWithoutStarred}`;
    default:
      return `selectListLabel.${StarredDisplayModeEnum.ShowAllIncludeStarred}`;
  }
};
